import React, { useState } from 'react';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import { DialogActions, DialogContent, Button, CircularProgress } from '@material-ui/core';
import MuiTableCell from "@material-ui/core/TableCell";
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useDataProvider, Loading, useTranslate } from 'react-admin';
import { Close, } from '@material-ui/icons'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import Radio from '@material-ui/core/Radio';
import DialogBackButton from '../common/dialog-back-button';
import { RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons'
import Paper from '@material-ui/core/Paper';
import { isNullOrUndefined } from 'util';
import Snackbar from '../common/snackbar';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        backgroundColor: theme.palette.background.default
    },
    containerSpacing: {
        paddingLeft: theme.spacing(6),
        marginRight: theme.spacing(3),
    },
    nameLabel: {
        fontSize: 18,
        fontFamily: 'UniviaPro-Medium',
        color: '#4f5064',
        lineHeight: 1.2
    },
    tableHeaderLabel: {
        fontSize: 13,
        fontFamily: 'UniviaPro',
        color: '#4f5064',
        lineHeight: 1.25
    }
}));


const TableCell = withStyles({
    root: {
        borderBottom: "none",
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0
    }
})(MuiTableCell);

const TableCellHead = withStyles({
    root: {
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 8
    }
})(MuiTableCell);

const CustomRadio = (props) => {
    return (
        <Radio
            {...props}
            icon={
                <RadioButtonUnchecked style={{ width: 24, height: 24 }} />}
            checkedIcon={
                <RadioButtonChecked style={{ width: 24, height: 24 }}
                    color='primary' />}
        />
    )
}

//header dialog
export const DialogHeader = ({ setSuccess, success, handleClose, setOpenDetail, loading, data }) => {
    const classes = useStyles()
    const translate = useTranslate();


    const onBackClick = () => {
        setOpenDetail({
            status: false,
            data: null
        });
    }

    React.useEffect(() => {
        setSuccess(false)
    }, [])

    if (loading) return null
    return (
        <Box className={classes.containerSpacing}>
            <Box display='flex' justifyContent='flex-end' alignContent='center' mt={2}>
                <Typography style={{ margin: 'auto 8px auto 0' }} variant='subtitle2'>  {translate(`pos.dashboard.close`)}</Typography>
                <CloseButton onClick={handleClose}/>
            </Box>
            <DialogBackButton onBack={onBackClick} label='Back to info Channels' />
            <Box alignContent='center' display='flex' mt={5.25}>
                <Box flexGrow={1} display='flex' alignItems='center'>
                    <Typography className={classes.nameLabel} >{data.name}</Typography>
                </Box>
                {
                    success && (
                        <Box width='30%'>
                            <Snackbar
                                show={success}
                                message={translate('resources.room.saveSuccess')}
                                onClose={() => setSuccess(false)}
                            />
                        </Box>
                    )
                }
            </Box>
        </Box>

    )
}

//Content diaalog
export const CustomDialogContent = ({ data, rooms, setRooms, loading, getList }) => {
    const classes = useStyles();
    const dataProvider = useDataProvider()
    const onChangeRadioButton = (event, index) => {
        var temps = rooms.slice()
        temps.map(item => {
            item.infoChannel = data.id
            return item
        })
        temps[index].type = event.target.name === 'priority' ? 2 : (event.target.name === 'default' ? 1 : 0)
        setRooms(temps)
    }
    React.useEffect(() => {
        getList()
    }, [])

    if (loading) return (<Box pt={3}>
        <Loading />
    </Box>)
    return (
        <DialogContent className={classes.containerSpacing} style={{ marginTop: 32 }} dividers={false}>
            <TableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCellHead>
                                <Typography className={classes.tableHeaderLabel}>Location</Typography>
                            </TableCellHead>

                            <TableCellHead align="center">
                                <Typography className={classes.tableHeaderLabel}>Not used</Typography>
                            </TableCellHead>
                            <TableCellHead align="center">
                                <Typography className={classes.tableHeaderLabel}>Default channel</Typography>
                            </TableCellHead>
                            <TableCellHead align="center">
                                <Typography className={classes.tableHeaderLabel}>Priority channel</Typography>
                            </TableCellHead>
                            <TableCellHead align="center"></TableCellHead>
                            <TableCellHead align="center"></TableCellHead>
                            <TableCellHead align="center"></TableCellHead>
                            <TableCellHead align="center"></TableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rooms.map((row, index) => (
                            <TableRow key={'channel-room' + index}>
                                <TableCell style={{ width: 200 }} align="left">
                                    <Typography className={classes.tableHeaderLabel}>{`${row.location} - ${row.name} (ID: ${row.number})`}</Typography>
                                </TableCell>
                                <TableCell style={{ width: 180 }} align="center">
                                    <CustomRadio
                                        checked={!row.type || row.type === 0}
                                        name='notUsed'
                                        onChange={(event) => onChangeRadioButton(event, index)}
                                    />
                                </TableCell>
                                <TableCell style={{ width: 180 }} align="center">
                                    <CustomRadio
                                        checked={row.type === 1}
                                        name='default'
                                        onChange={(event) => onChangeRadioButton(event, index)}
                                    />
                                </TableCell>
                                <TableCell style={{ width: 180 }} align="center">
                                    <CustomRadio
                                        checked={row.type === 2}
                                        name='priority'
                                        onChange={(event) => onChangeRadioButton(event, index)}
                                    />
                                </TableCell>

                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>


                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
    );
}

//action dialog
export const DialogAction = ({ setSuccess, setRooms, rooms, data, setOpenDetailInfoChannel, loading }) => {
    const classes = useStyles()
    const theme = useTheme();
    const dataProvider = useDataProvider()
    const [loadingButton, setLoadingButton] = useState(false)


    const onChangeRadioAll = (event) => {
        let temps = rooms.slice()
        rooms.forEach((value, index) => {
            temps[index].infoChannel = data.id
            temps[index].type = event.target.name === 'priority' ? 2 : (event.target.name === 'default' ? 1 : 0)
        })
        setRooms(temps)
    }

    const onSave = () => {
        setLoadingButton(true)
        dataProvider('CREATE', "infochannels/assigntoroom", {
            data: {
                infoChannels: rooms.filter(value => !isNullOrUndefined(value.type))
            }
        })
            .then(({ data }) => {
                setSuccess(true)
                setLoadingButton(false)
                setTimeout(() => {
                    setSuccess(false);
                }, 5000);
            })
            .catch(() => {
                setLoadingButton(false)
            })
    }
    if (loading) return null
    return (
        <DialogActions style={{ padding: 0 }}>
            <Paper style={{ width: '100%', borderRadius: 0, paddingLeft: 48, paddingRight: 40 }}>
                <TableContainer>
                    <Table aria-label="simple table">
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ width: 200 }} align="left">
                                    <Typography variant='body1' color='primary'>Select all</Typography>
                                </TableCell>
                                <TableCell style={{ width: 180 }} align="center">
                                    <CustomRadio
                                        checked={rooms.filter(element => !element.type || element.type === 0).length === rooms.length}
                                        name='notUsed'
                                        onChange={onChangeRadioAll}
                                    />
                                </TableCell>
                                <TableCell style={{ width: 180 }} align="center">
                                    <CustomRadio
                                        checked={rooms.filter(element => element.type === 1).length === rooms.length}
                                        name='default'
                                        onChange={onChangeRadioAll}
                                    />

                                </TableCell>
                                <TableCell style={{ width: 180 }} align="center">
                                    <CustomRadio
                                        checked={rooms.filter(element => element.type === 2).length === rooms.length}
                                        name='priority'
                                        onChange={onChangeRadioAll}
                                    />
                                </TableCell>

                                <TableCell align="right"></TableCell>
                                <TableCell align="right"> </TableCell>
                                <TableCell align="right">
                                    <Button onClick={() => { setOpenDetailInfoChannel(false) }} color='primary' style={{ marginRight: 24 }}>Cancel</Button>
                                    <Button onClick={onSave} disabled={loadingButton} variant='contained' color='primary'>
                                        {
                                            loadingButton ? (
                                                <CircularProgress
                                                    size={15}
                                                    thickness={2}
                                                    color='inherit'
                                                />
                                            ) :
                                                'Save'
                                        }
                                    </Button>
                                </TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </DialogActions>
    )
}

